module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.boletos.boletos), function(bol) {
    return _c('tr', {
      key: bol.id
    }, [_c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(bol.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bol.id + '-' + bol.digito))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-transform": "uppercase"
      }
    }, [_vm._v(_vm._s(bol.garantia.pessoa.nome_razao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(bol.vencimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(bol.valor_garantido, 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm._f("numberFormat")(bol.prorata, 2, ',', '.')) + "\n                    "), _c('small', [_vm._v("(" + _vm._s(bol.qtd_dias) + " dias)")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(bol.antecipacao, 2, ',', '.')))])])
  }), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("numberFormat")(_vm.boletos.totais.total_boletos, 2, ',', '.')))])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("numberFormat")(_vm.boletos.totais.total_prorata, 2, ',', '.')))])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("numberFormat")(_vm.boletos.totais.total_taxa_antecipacao, 2, ',', '.')))])])])], 2)]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("dataHoraFormatada")(_vm.boletos.totais.data_simulacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.boletos.totais.qtd_boletos))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(_vm.boletos.totais.total_boletos, 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(_vm.boletos.totais.total_prorata, 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(_vm.boletos.totais.total_taxa_antecipacao, 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(_vm.boletos.totais.taxa_basica, 2, ',', '.')))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("numberFormat")(_vm.boletos.totais.total_antecipacao, 2, ',', '.')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center",
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "tag": "button",
      "to": "/operacao/antecipacoes"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        return _vm.salvar()
      }
    }
  }, [_vm._v("\n              Enviar Solicitação\n              "), _c('small', [_vm._v("(Sujeito a análise)")])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Simulação da Antecipação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("Relação de boletos em aberto para antecipação")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Garantia")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Cliente")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Vencimento")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Prorata")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Taxa")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Subtotal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("Resumo")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("Qtd. de Boletos")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("Total Boletos")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("Prorata")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("Taxa Antecipação")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("Taxa Básica")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("Total da Antecipação")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce2c86ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operacao/antecipacao/form.vue
// module id = 415
// module chunks = 1